module.exports = __webpack_public_path__ + "static/media/singlecell.d45fc847.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/singlecell.png
// module id = 64
// module chunks = 0